export const FamilyList = {
  UserDetail: {
    Button: {
      Delete: '削除する',
    },
    Text: {
      Confirm: 'このユーザーを削除しますか？',
    },
  },
  AddFamily: {
    Header: {
      Title: '家族の追加',
    },
    Content: {
      Add: '追加する',
    },
  },
  List: {
    Header: {
      Title: '家族一覧',
    },
    Content: {
      AddFamily: '家族を追加する',
    },
  },
};
